import { render, staticRenderFns } from "./cateOptions.vue?vue&type=template&id=70b94eec&scoped=true"
import script from "./cateOptions.vue?vue&type=script&lang=js"
export * from "./cateOptions.vue?vue&type=script&lang=js"
import style0 from "./cateOptions.vue?vue&type=style&index=0&id=70b94eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b94eec",
  null
  
)

export default component.exports